import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=52330645&"
import script from "./HomePage.vue?vue&type=script&lang=js&"
export * from "./HomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52330645')) {
      api.createRecord('52330645', component.options)
    } else {
      api.reload('52330645', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=52330645&", function () {
      api.rerender('52330645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/HomePage.vue"
export default component.exports